import React from 'react';
import { Button, Modal, Toast, Badge, Icon } from 'antd-mobile';
import {post} from '../../utils/request';
import cookies from 'js-cookie';
import api from '../index/api';
import { getUrlParam, href } from '../../utils/util';

import { wxfx } from '../../utils/wxfx.js';

import './index.less';
// import { div } from 'react/lib/ReactDOMFactories';

class informationCollectionListIndentity extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            statictisData: {},
            urlOps:{},
            collectedContent1:'',
            collectedContent2:''
        };
    }

    componentDidMount() {
        document.getElementsByTagName('body')[0].style.cssText = 'background: #F4F4F5 !important';
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                if(ops.app_stoken && ops.app_stoken != 'null'){ 
                    post({
                        url: api.selectCollectedPersonalInfoList + '?app_stoken=' + this.state.urlOps.app_stoken,
                        data: {}
                    }).then((res) => {
                        if(res.result === 'success'){
                            this.setState({
                                statictisData: res.data
                            }),()=>{
                            }
                            this.formatData()
                            // if(this.state.statictisData[0]){
                            //    let collectedCountData= this.state.statictisData[0].collectedContent
                            //     let strIng1 = this.desensitization(collectedCountData.toString(), 1, -1)
                            //     this.setState({
                            //         collectedCount:strIng1,
                            //     })
                            // }
                            // if(this.state.statictisData[3]&&this.state.statictisData[3].collectedContent){
                            //     let collectedContentlData= this.state.statictisData[3].collectedContent
                            //     let strIng2 = this.desensitization(collectedContentlData.toString(), 1, -1)
                            //     this.setState({
                            //         collectedCotent:strIng2
                            //     })
                            // }
                        }else{
                            Toast.info(res.msg,1);
                        }
                    }, (res)=>{
                        Toast.info('获取统计数据失败',1);
                    });
                }
                
                
            });
            
        }
    }
    formatData(){
        var {statictisData} = this.state; 
        if(statictisData[0]){
            let collectedContentlData1= statictisData[0].collectedContent
            let strIng1 = this.desensitizationName(collectedContentlData1.toString(), 1, -1)
            this.setState({
                collectedContent1:strIng1,
            })
         }
         if(statictisData[3]&&statictisData[3].collectedContent){
            let collectedContentlData2= statictisData[3].collectedContent
            let strIng2 = this.desensitization(collectedContentlData2.toString(), 1, -1)
            this.setState({
                collectedContent2:strIng2
            })
         }
    }
    //姓名字符串脱敏
    desensitizationName(str, beginLen, endLen){
        let len = str.length;
        let firstStr = str.substr(0, beginLen);
        let lastStr = str.substr(endLen);
        let middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
        let tempStr = firstStr+middleStr;
        // let middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
        // let tempStr = firstStr+middleStr+lastStr;
        return tempStr;
    }
    //身份证字符串脱敏
    desensitization(str, beginLen, endLen){
        let len = str.length;
        let firstStr = str.substr(0, beginLen);
        let lastStr = str.substr(endLen);
        let middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
        let tempStr = firstStr+middleStr+lastStr;
        return tempStr;
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }
    appInformation(){
        let viewPort = this.viewPort();
        if (
            viewPort.ios ||
            viewPort.iPhone ||
            viewPort.iPad
        ) {
            if(window.webkit){
                window.webkit.messageHandlers.information.postMessage('1');
            }
        } else {
            if(window.huilian){
                window.huilian.information('1');
            }
        }
    }

    render() {
        let _this = this;
        var {urlOps,statictisData,collectedContent2,collectedContent1} = this.state; 
        return (
            <div className="informationCollectionListIndentityBox">
                <div className="blockBox">
                    <h2>姓名</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>实名认证</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>用户进行实名认证时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>{statictisData[2] && statictisData[2].collectedCount?statictisData[2].collectedCount:'- -'}条</p></div>
                            </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            {/* <div className='right'><p>{statictisData[2] && statictisData[2].collectedContent?statictisData[2].collectedContent:'- -'}</p></div> */}
                            <div className='right'><p>{collectedContent1?collectedContent1:'- -'}</p></div>
                            </div>
                    </div>
                </div>
                <div className="blockBox" style={{ marginTop: '0.16rem' }}>
                    <h2>实名认证</h2>
                    <div className="block-mini">
                        <div className='listItem'>
                            <div className="left"><p> 使用目的</p></div>
                            <div className='right'><p>实名认证</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 使用场景</p></div>
                            <div className='right'><p>用户进行实名认证时</p></div>
                        </div>
                        <div className='listItem'>
                            <div className="left"><p> 收集情况</p></div>
                            <div className='right'><p>{statictisData[3] && statictisData[3].collectedCount?statictisData[3].collectedCount:'- -'}条</p></div>
                            </div>
                        <div className='listItem'>
                            <div className="left"><p> 信息内容</p></div>
                            {/* <div className='right'><p>{statictisData[3] && statictisData[3].collectedContent?statictisData[3].collectedContent:'- -'}</p></div> */}
                            <div className='right'><p>{collectedContent2?collectedContent2:'- -'}</p></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default informationCollectionListIndentity;


// WEBPACK FOOTER //
// ./src/informationCollectionList/indentity/index.js